import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M3.857 3.857a6.34 6.34 0 0 1 9.464 8.403l3.836 3.837a.75.75 0 1 1-1.06 1.06l-3.837-3.836a6.34 6.34 0 0 1-8.403-9.464M8.339 3.5a4.84 4.84 0 1 0 0 9.679 4.84 4.84 0 0 0 0-9.679"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSearch;
